module.exports = __webpack_public_path__ + "img/floorplan-tunnel-club.23e869f7.png";